export default "__VITE_ASSET__bb22a1f3__"